<template>
  <v-card>
    <v-card-text>
      <div class="text-center text-overline mt-2">{{ label }}</div>
      <div class="bar-chart" :style="{ height: isMobile ? '400px' : '300px' }">
        <div v-for="(item, index) in chartData" :key="index" :class="chartData.length <= 4 ? 'bar' : 'wide-bar'">
          <div class="bar-value-wrapper">
          <div class="bar-label">{{ item.value | formatCurrency(currencyForFormatting) }}</div>
            <div
            class="bar-value"
            :style="{ height: getHeightPercentage(item.value) + '%' }"
          ></div>
          </div>
          <div class="bar-label">{{ item.category }}</div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  name: 'SimpleBarChart',
  props: {
    data: Array,
    label: String,
    chosenCurrency: {
      type: Object,
      default: () => ({ })
    }
  },
  computed: {
    chartData () {
      return this.data.map((item) => ({
        category: item.category,
        value: item.value
      }))
    },
    isMobile () {
      return this.$vuetify.breakpoint.mobile
    },
    currencyForFormatting () {
      return { ...this.chosenCurrency }
    }
  },
  methods: {
    getMaxValue () {
      return Math.max(...this.chartData.map((item) => item.value))
    },
    getHeightPercentage (value) {
      const maxValue = this.getMaxValue()
      return value / maxValue * 100
    }
  }
}
</script>

<style scoped lang="scss">
$bar-color: #2071b5;
.bar-chart {
  display: flex;
  align-items: flex-end;
  padding: 10px;
  justify-content: center;
  margin: 0px 30px;
}

.bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  height: 100%;
  justify-content: center;
  margin: 10px;
}

.wide-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 140px;
  height: 100%;
  justify-content: center;
  margin: 10px;
}

.bar-label {
  margin-bottom: 10px;
  font-size: 12px;
  text-align: center;
  width: 120px;
  height: 20px;
}

.bar-value-wrapper {
  height: 300px;
  width: 60%;
  align-items: center;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.bar-value {
  color: white;
  background-color: $bar-color;
  width: 40%;
  text-align: center;
  font-size: 12px;
  margin-bottom: 10px;
  max-height: 100%;
}
</style>
